import oliasoftLogo from 'src/assets/logo.png';
import forecastLogo from 'src/assets/logo-forecast.png';
import { IProjectsOverview } from 'client/common/interfaces/project.ts';
import { addTextField } from 'views/report/utils/add-text-field/add-text-field.ts';
import { addHierarchyData } from 'views/report/utils/add-hierarchy-data.ts';
import { getCenterXPosition, getFormattedTime, getPageHeight, getPageWidth } from 'views/report/utils/utils.ts';
import {
  fontBold,
  fontMainSize,
  fontNormal,
  fontSecondarySize,
  fontSmallSize,
  padding,
} from 'views/report/utils/style-consts.ts';
import { warmGrayColor } from 'views/report/colors.ts';

const addBottomCoverLogo = (doc: any): void => {
  const forecastLogoProps = doc.getImageProperties(forecastLogo);
  const forecastLogoWidth = 35;
  const forecastLogoHeight = (forecastLogoProps.height * forecastLogoWidth) / forecastLogoProps.width;

  const pageHeight = getPageHeight(doc);
  const centerXPosition = getCenterXPosition(doc);

  const fontSize = doc.getFontSize();
  const lineHeight = doc.getLineHeight();

  doc.setFont(fontNormal.fontName, fontNormal.fontStyle);
  doc.setTextColor(warmGrayColor);
  doc.setFontSize(fontSmallSize);

  const textLogoPositionX = centerXPosition - padding / 2;
  const textLogoPositionY = pageHeight - forecastLogoHeight / 2 + (lineHeight - fontSize) - padding;

  // TODO: Add translations
  doc.text('Soft catalyst for hard change', textLogoPositionX, textLogoPositionY, { align: 'right' });

  const forecastLogoPositionX = centerXPosition + padding / 2;
  const forecastLogoPositionY = pageHeight - forecastLogoHeight - padding;

  doc.addImage(
    forecastLogo,
    'PNG',
    forecastLogoPositionX,
    forecastLogoPositionY,
    forecastLogoWidth,
    forecastLogoHeight,
  );
};

export const addCoverPage = (doc: any, projectOverview: IProjectsOverview): void => {
  const { design } = projectOverview;

  const initialY = 60;
  const logoImageWidth = 58;
  const logoImageHeight = 58;
  const logoImageYPosition = 60;
  const logoImageXPosition = (getPageWidth(doc) - logoImageWidth) / 2;

  doc.addImage(oliasoftLogo, 'PNG', logoImageXPosition, logoImageYPosition, logoImageWidth, logoImageHeight);

  const projectOverviewTextFieldCoordinates = addTextField(doc, {
    name: projectOverview.name,
    y: initialY + logoImageHeight + fontMainSize / 2,
    isCentered: true,
    useValue: false,
    font: fontBold,
    fontSize: fontMainSize,
  });

  const designNameTextFieldCoordinates = addTextField(doc, {
    name: design.name,
    isCentered: true,
    y: projectOverviewTextFieldCoordinates.y + padding,
    useValue: false,
    fontSize: fontMainSize,
    font: fontNormal,
  });

  addTextField(doc, {
    name: `${projectOverview.companyName} · ${getFormattedTime()}`,
    isCentered: true,
    y: designNameTextFieldCoordinates.y + padding * 2,
    useValue: false,
    fontSize: fontSecondarySize,
    font: fontNormal,
  });

  addHierarchyData(doc, projectOverview, 200);
  addBottomCoverLogo(doc);
};
